import React from "react";
import axios from 'axios';
import { useEffect, useState } from 'react';
// import Loader from "../components/Loader";
import { useNavigate } from "react-router-dom";
import { getNBNApiHeader } from "utlis/commonfunctions";



const Cart = ({ defaultPlan, defaultModem, checkVispValid, addressVerify, vispID ,shippingCharge,gstshippingCharge,userToken}) => {
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiKey = process.env.REACT_APP_API_TOKEN;
  const headers = getNBNApiHeader();

  const [defaultPlanID, setDefaultPlanID] = useState(false);
  const [defaultPlanName, setDefaultPlanName] = useState(false);
  const [defaultPlanAmount, setDefaultPlanAmount] = useState('0');
  const [defaultModemID, setDefaultModemID] = useState(false);
  const [defaultModemName, setDefaultModemName] = useState(false);
  const [defaultModemAmount, setDefaultModemAmount] = useState('0');
  const [defaultshippingCharge, setdefaultshippingCharge] = useState('0');
  const [isNotValidVisp, setIsNotValidVisp] = useState(false);
  const [isLoading,setIsLoading] = useState(false);
  const [totalCart, setTotalCart] = useState('0');
  const [gstPlanAmount,setGstPlanAmount]=useState("0")
  const[gstModemAmount,setGstModemAmount]=useState("0")





  useEffect(() => {

    if (defaultPlan) {
      setDefaultPlanID(defaultPlan.plan_id);
      setDefaultPlanName(defaultPlan.website_plan_name);
      setDefaultPlanAmount(defaultPlan.rtap_sale_amount);
      setGstPlanAmount(defaultPlan.gst_inclusive_sale_amount)


    }

    if (defaultModem) {
      if (defaultModem.nbn_product_id !== undefined) {
        setDefaultModemID(defaultModem.nbn_product_id);
        setDefaultModemName(defaultModem.nbn_product_name);
        setDefaultModemAmount(defaultModem.product_website_sell_amount);
        setGstModemAmount(defaultModem.gst_inclusive_sale_amount)

      }
    } else {
      setDefaultModemID(false);
      setDefaultModemName(false);
      setDefaultModemAmount('0');
      setGstModemAmount("0")
    }

    setdefaultshippingCharge(shippingCharge);
    
    setTotalCart((Number(gstPlanAmount)+ Number(gstshippingCharge) + Number(gstModemAmount)).toFixed(2));
  });


  const checkValidAddressVisp = async () => {
    setIsNotValidVisp(false);
   
    if(addressVerify===false){
      setIsNotValidVisp(true);
      
      const releventDiv = document.getElementById('AdressSelectBox');
      releventDiv.scrollIntoView({ behavior: "smooth" });
    }else{
      
  

    const payload = {
      "visp_qualification_id": vispID,
      "plan_id": defaultPlan.plan_id,
      "product_id":defaultModemID
     
    }

    
    let res;
    try {
      setIsLoading(true);
      // setTimeout(() => {
      // }, 10000);
      
      res = await axios.post(apiUrl + 'nbn/update-order-details', payload, {headers:headers});
      
      setTimeout(() => {
       
        if (res.status === 200) {
         
         
          navigate("/checkout", {
            state: {
              vispID: vispID,
              plan_id: defaultPlan.plan_id,
              product_name:defaultModemName,
              product_amount:defaultModemAmount,
              amount: totalCart,
              shipping_charge: shippingCharge,
              gst_plan_amount:gstPlanAmount,
              gst_modem_amount:gstModemAmount,
              gst_shipping_charge:gstshippingCharge
            }
          });
        } else {
          console.log("Error: Unexpected status code ", res.status);
        }
        setIsLoading(false);
      }, 2000); // 2 seconds delay
    } catch (error) {

      setIsLoading(false);
    }

  }
    }
    
  return (


    <div className="container-fluid" style={{ backgroundColor: '#000' }}>
      <section className="result-section">
        <div className="container">
        <div className="row">
        <div className="result-header-title">
              <h2>4. Ready for Checkout: Selected Items.</h2>
              <p>Reviewing  checkout page allows you to confirm and modify your order information before completing your transaction.</p>
            </div>
          <div className="col-md-12">
            <center>
              <table className="table table-dark table-hover table-striped">
                <tbody>

                  <tr>
                    <td style={{ borderTopLeftRadius: '30px' }}>{defaultPlanName}</td>
                    <td style={{ textAlign: 'right' }}>${defaultPlanAmount}</td>
                  </tr>
                  {defaultModemID && (
                    <tr>
                      <td >{defaultModemName} & Shipping charge</td>
                      <td style={{ textAlign: 'right' }}>${(Number(defaultModemAmount)+Number(shippingCharge)).toFixed(2)}</td>
                    </tr>
                  )}

                  <tr>
                    <td>Total upfront cost</td>
                    <td style={{ textAlign: 'right' }}>${totalCart} </td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr>
                    <td style={{ fontWeight: '300' }}>TOTAL MONTHLY COST</td>
                    <th style={{ borderBottomRightRadius: '30px', borderColor: 'transparent' }}>${defaultPlanAmount}/Month</th>
                  </tr>
                  </tfoot>
              </table><br />

              {isNotValidVisp && addressVerify === false &&(

                <p>
                  <span style={{ color: '#fff', textAlign: 'center' }}>This address can't be serviced.</span>
                </p>

              )}


<button className="button-57" role="button" disabled={isLoading} onClick={e => checkValidAddressVisp()}> {isLoading ? <> <span className="text">Processing.....</span> <span>Processing.....</span> </> : <> <span className="text">ORDER NOW</span> <span>ORDER NOW</span></>}</button></center>
          
          <br/>
          </div>
        </div>
        </div>
      </section>
    </div>




  );
}

export default Cart;
